import type {GetProductsData, GetProductsResponse, Product} from '@myparcel-frontend/product-service';
import {defineStore} from 'pinia';
import {ref} from 'vue';

export const useProductStore = defineStore('products', () => {
  const products = ref<Product[]>([]);
  const productFilters = ref<NonNullable<GetProductsData['query']>['filter']>({});
  const productQuery = ref<NonNullable<GetProductsData['query']>['query']>('');
  const productAggregations = ref<GetProductsResponse['aggregations']>();

  const addProduct = (newProduct: Product): void => {
    products.value.push(newProduct);
  };

  const upsertProduct = (changedProduct: Product): void => {
    const index = products.value.findIndex((product) => product.id === changedProduct.id);

    if (index === -1) {
      addProduct(changedProduct);

      // update if the pre-existing product has no updatedAt value OR if the changed product has a newer updatedAt value
    } else if (!products.value[index].updatedAt || changedProduct.updatedAt! > products.value[index].updatedAt) {
      products.value[index] = changedProduct;
    }
  };

  const upsertProducts = (newProducts: Product[]): void => {
    newProducts.forEach((product) => {
      upsertProduct(product);
    });
  };

  const productById = (id: string): Product => {
    return products.value.find((product) => product.id === id)!;
  };

  return {
    productAggregations,
    productFilters,
    productQuery,
    products,
    addProduct,
    productById,
    upsertProduct,
    upsertProducts,
  };
});
